<template>
  <div>
    <div class="auto-height">

      <div class="row mt-2">
        <div class="col-sm-5">
          <label class="pl-2" for="">{{ $t('maintenance.organizations.table.name') }}</label>
        </div>
        <div class="col-sm-7">
          <div class="float-right" style="width:452px;">
            <label for="">{{ $t('maintenance.organizations.table.members') }}</label>
          </div>
        </div>
      </div>

      <div class="table-list-block text-center" v-if="!loading && treeData.children && !treeData.children.length">
        <h5 class="mt-3">
          {{ $t('system.no_results') }}
        </h5>
      </div>

      <OrganizationTreeListViewItem
          class="cursor-pointer"
          v-for="(child, index) in treeData.children"
          :item="child"
          :key="index"
          :selectedOrganization="selectedOrganization"
          v-if="treeData.children && treeData.children.length"
          @updateList="updateList"
      ></OrganizationTreeListViewItem>

    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import OrganizationTreeListViewItem from '@/components/organizations/OrganizationTreeListViewItem.vue';

export default {
  name: 'OrganizationTreeListView',
  data: function() {
    return {
      treeData: {
        name: this.$t('administration.users.create.organization_expand_label'),
        children: []
      },
      loading: true,
      selectedOrganization: {}
    }
  },
  props: {
    organization: Object
  },
  watch: {
    getClient: function () {
      this.treeData = {
        name: this.$t('administration.users.create.organization_expand_label'),
        children: []
      },
      this.loadItems();
    },
    getSelectedOrganization: function (newValue, oldValue) {
      this.$emit('updatedCompany', newValue)
    }
  },
  components: {
    OrganizationTreeListViewItem
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getSelectedOrganization() {
      return this.selectedOrganization
    }
  },
  methods: {
    loadItems(setActive) {
      let self = this;
      piincHttp.get('organizations', { params:
        {
          tree: 1,
          per_page: 100,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.loading = false;
        self.treeData.children.push(...response.data.items)
      }, function() {});
    },
    updateList(item) {
      this.treeData = {
        name: this.$t('administration.users.create.organization_expand_label'),
        children: []
      },

      this.loadItems()
    },
    resetSelected() {
      this.selectedOrganization = {}
    }
  },
  created () {
    this.loadItems()
    if (this.organization && this.organization.id) {
      this.updateSelected(this.organization)
    }
  }
}
</script>
